import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

export class TrainingVideoFetchRequest {
    public static readonly FetchRequestType: string = "training_video_master_fetch_request";
    state_ids: number[] = [];
    training_video_ids: number[] = [];


    public MergeIntoTransportData = (td: TransportData) => {
        let coll = DataContainerService.GetInstance().GetOrCreateCollection(td.MainData, TrainingVideoFetchRequest.FetchRequestType) as DataCollection;
        coll.Entries.push(this);
    }

    public FormulateTransportData = () => {
        let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
        this.MergeIntoTransportData(td);

        return td;
    }
}

